function loadScripts() {
var templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/event.js?v=129793407935769848231742473581");
  loadScript("https://bridge.shopflo.com/js/shopflo.bundle.js");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/devx-script.js?v=5195211133432327801741773571");  
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/all.min.js?v=155899187558914370431734761480");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/product-form.js?v=27126810297118959231744394825");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/shopflo.bundle.js?264267");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/pubsub.js?v=137775062529952147391744908934");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/cart-notification.js?v=133508293167896966491733234010");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/search-form.js?v=133129549252120666541733234008");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/quantity-popover.js?v=987015268078116491733234008");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/quantity-popover.js?v=987015268078116491733234008");
  // loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/global.js?v=142901196702149857411745496316");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/shop-all.js?v=161938851034242814281744693222");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/quick-add.js?v=73073840428863680991733234009");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/facets.js?v=131212339141062344381733234009");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/show-more.js?v=135784227224860024771733234008");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/st_offers.js?v=97271521920504297941742820130");
  

  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/quantity-popover.css?v=76231206801088522361733234008");
 
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/npdp-color-swatch.css?v=78056110400969161621741781874");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/all.min.css?v=36347114306294163891734761376");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-price.css?v=70172745017360139101733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-card.css?v=120341546515895839841733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-cart.css?v=49529066954642232561733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-mega-menu.css?v=122458266873942644791741586250");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-totals.css?v=45024014013762792871733295103");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-cart-drawer.css?v=70537380569719218011733295078");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-discounts.css?v=152760482443307489271733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/searchtap.css?v=38944599448503634721733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-list-menu.css?v=151968516119678728991733234008");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-search.css?v=165164710990765432851733234008");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-menu-drawer.css?v=20646116693146970981733234010");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-cart-notification.css?v=54116361853792938221733234008");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-cart-items.css?v=148769278334350210081733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-collection-hero.css?v=150137544140055157131733234009");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/quick-add.css?v=66647833350618835731733234008");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-show-more.css?v=139536189637226996221733234008");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-swatch-input.css?v=61683592951238328641733234008");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1315/assets/component-swatch.css?v=68619770617697936771733234008");
  
 


 
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/details-modal.js?v=25581673532751508451733234008");
  loadScript("//www.dotandkey.com/cdn/shop/t/1315/assets/details-disclosure.js?v=13653116266235556501733234009");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
